import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { title } from 'process';
import { Observable } from 'rxjs';
import { Call, CallGmao, CallsCount, Tab } from 'src/app/model/call/call.model';
import { CallService } from 'src/app/services/http/call/call.service';



@Component({
  selector: 'app-calls-list',
  templateUrl: './calls-list.component.html',
  styleUrls: ['./calls-list.component.scss']
})
export class CallsListComponent implements OnInit {

  @Output() openCalls = new EventEmitter<Tab>();

  constructor(private service: CallService) { }

  public appels!: Call;
  public nbAppels !: CallsCount;
  public nbPages !: number;
  public p : any = 0;

 public btnClicked : boolean = false;

  ngOnInit(): void {

    // Get the total number of calls 
    this.service.getCallsCount()
      .subscribe(
        (nbAppels) => {
          //console.log(nbAppels.sav_suivis_count);
          this.nbAppels = nbAppels;
          this.nbPages = Math.ceil(nbAppels.sav_suivis_count/30);
        })

      this.GetCalls(this.p);
     
    
  
  }


  public pageChange(e: any)  {
    this.p = e;
    this.GetCalls((this.p) - 1);
  }


  public GetCalls(page : any) {
    this.service.getCallsListData((page).toString()).subscribe(
      (appels) => {
        appels.suivis.forEach(appel => {
          this.service.getCallStateData(appel.id_sav_suivi.toString()).subscribe(
            (state)=> {
              if(state[0]){
              appel.state = state[0];}
            }
          )
        });
        this.appels = appels;
      });
  }

  clickCall(callId : number,title : string,mode : string){
    // window.open('call/'+ callId,'_blank')
    this.openCalls.emit({id_suivi:callId,title:title,mode:mode});
  }
  


}


